// extracted by mini-css-extract-plugin
export default {"Strong":"webpack-components-core-Typography-components-Strong-Strong-module__Strong"};